<style src="./ContextGroupRemove.scss" lang="scss"></style>
<template>
  <section class="context-group-remove">
    <div
      class="option"
      @click="openModalConfirm">
      <icon-garbage class="icon" />
      <span class="title">Remover esse grupo</span>
    </div>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmRemoveGroup"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />

        <div class="description">
          <p class="info">
            Essa ação irá remover esse grupo por completo e de forma permanente.
          </p>
          <p class="info">
            Tem certeza que deseja <strong>excluir</strong>?
          </p>
        </div>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="removeGroup"
          class="cmdapply">

          <button-submit
            label="Sim, quero excluir"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave, IconGarbage } from '@/components/primitives/icons'

export default {
  name: 'ContextGroupRemove',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave,
    IconGarbage
  },
  props: {
    group: null
  },
  data: () => ({
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmRemoveGroup')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmRemoveGroup')
    },
    async removeGroup () {
      try {
        await this.$store.dispatch('ItemPricing/REMOVE_DYNAMIC_GROUP', {
          groupId: this.group.groupId
        })
        this.reloadEvent()
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmRemoveGroup')
        this.$emit('close')
      }
    },
    async reloadEvent () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      await this.$store.dispatch('ItemPricing/LIST_ALL_ITEMS', { eventId })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-group-remove/ContextGroupRemove.vue